import type { TopicConfig } from "../registry/topics";

export function ViewHeader({ topic }: { topic: TopicConfig }) {
  return (
    <header className="mb-[var(--space-section)] flex flex-wrap items-center justify-between gap-3">
      <div>
        <h1
          className="font-semibold text-text-primary"
          style={{ fontSize: "var(--font-heading)" }}
        >
          {topic.title ?? topic.label}
        </h1>
      </div>

      {topic.id === "infra" ? (
        <span className="text-text-secondary" style={{ fontSize: "var(--font-micro)" }}>
          FCR infra ~10s · host-load 1 Hz · gw/ws/stats ~5s · live WS
        </span>
      ) : null}
    </header>
  );
}
